import React from 'react';
import ReactPaginate from 'react-paginate';

const prevArrow = '\u2039';
const nextArrow = '\u203A';

const Pagination = ({ classNames = '', currentPage, handlePageClick, numPages }) => {
  // (bnikom) don't show if not enough items to paginate
  if (numPages <= 1) return null;

  /** (bnikom)
   * in order to reset pagination on setState (aka any filter),
   * we need to track what page we are currently on, and pass that into forcePage
   *
   * don't show first/last arrow if you are on the first/last page
   * */
  return (
    <ReactPaginate
      activeClassName="active"
      breakLabel="..."
      breakClassName="break-me"
      containerClassName={`font-arial pagination mb-4 justify-content-center ${classNames}`}
      forcePage={currentPage}
      marginPagesDisplayed={1}
      nextLabel={(currentPage + 1) !== numPages && nextArrow}
      onPageChange={handlePageClick}
      pageCount={numPages}
      pageRangeDisplayed={4}
      previousLabel={(currentPage + 1) !== 1 && prevArrow}
      subContainerClassName="pages pagination"
    />
  );
};

export default Pagination;
